<template>
  <div class="projets">
    <div class="color-legend">
      <div class="legend-item">
        <span class="color-dot personal"></span>
        <span class="legend-text">Projets Personnels</span>
      </div>
      <div class="legend-item">
        <span class="color-dot educational"></span>
        <span class="legend-text">Projets Scolaires</span>
      </div>
      <div class="legend-item">
        <span class="color-dot internship"></span>
        <span class="legend-text">Projets Stages</span>
      </div>
    </div>
    <h1>Mes Projets</h1>
    <div class="timeline">
      <div class="year-separator">
        <span class="year">2026</span>
      </div>

      <div class="timeline-item right">
        <div class="projet-card internship clickable" @click="$router.push('/stage-arbre-de-vie')">
          <div class="date">Janvier 2026</div>
          <div class="projet-title">
            <img src="@/assets/logo_arbredevie.png" alt="Logo L'Arbre de Vie" class="projet-icon">
            <h3>Stage — L'Arbre de Vie</h3>
          </div>
          <div class="project-descriptions">
            <span class="description">Mettre à disposition des utilisateurs un service informatique</span>
            <span class="description">Gérer le patrimoine informatique</span>
            <span class="description">Répondre aux incidents et aux demandes d'assistance et d'évolution</span>
            <span class="description">Travailler en mode projet</span>
          </div>
          <p>
            Stage de deuxième année de BTS SIO SISR au sein de l'association L'Arbre de Vie à Brest.
            Déploiement d'un système de blocage de publicités à l'échelle du réseau via DNS : installation
            de Pi-hole dans un premier temps, puis migration vers AdGuard Home déployé sur Docker pour
            une solution plus moderne et maintenable.
          </p>
          <div class="tags">
            <span class="tag">Raspberry Pi</span>
            <span class="tag">Docker</span>
            <span class="tag">AdGuard Home</span>
            <span class="tag">Pi-hole</span>
            <span class="tag">DNS</span>
            <span class="tag">Linux</span>
            <span class="tag">Réseau</span>
            <span class="tag">Cybersécurité</span>
          </div>
          <div class="view-more">Voir plus de détails</div>
        </div>
      </div>

      <div class="year-separator">
        <span class="year">2025</span>
      </div>

      <div class="timeline-item left">
        <div class="projet-card educational clickable" @click="$router.push('/projet-gsb')">
          <div class="date">Septembre 2025</div>
          <div class="projet-title">
            <img src="@/assets/gsblogo.png" alt="Logo GSB" class="projet-icon">
            <h3>Projet GSB</h3>
          </div>
          <div class="project-descriptions">
            <span class="description">Gérer le patrimoine informatique</span>
            <span class="description">Répondre aux incidents et aux demandes d’assistance et d’évolution</span>
            <span class="description">Développer la présence en ligne de l’organisation</span>
            <span class="description">Travailler en mode projet</span>
          </div>
          <p>
            Projet d'AP du premier semestre de deuxième année consistant à mettre en place un réseau d'entreprise fictif
            sur
            vSphère avec VMWARE.
            Le principe de ce projet c'est de mettre en place de nombreux services en haute disponibilité de répliquer
            les bases de données.
          </p>
          <div class="tags">
            <span class="tag">VMWARE</span>
            <span class="tag">vSphere</span>
            <span class="tag">Active Directory</span>
            <span class="tag">OPNsense</span>
            <span class="tag">Virtualisation</span>
            <span class="tag">Active Directory</span>
            <span class="tag">DMZ</span>
            <span class="tag">Haute Disponibilité</span>
            <span class="tag">IPAM</span>
            <span class="tag">Apache2</span>
            <span class="tag">Base de données</span>
          </div>
          <div class="view-more">Voir plus de détails</div>
        </div>
      </div>

      <div class="timeline-item right">
        <div class="projet-card personal clickable" @click="$router.push('/projet-pokepullerweb')">
          <div class="date">Juin 2025</div>
          <div class="projet-title">
            <img src="@/assets/logo_pokepuller.png" alt="Logo PokePuller" class="projet-icon">
            <h3>Site Web "PokePuller"</h3>
          </div>
          <div class="project-descriptions">
            <span class="description">Gérer le patrimoine informatique</span>
            <span class="description">Répondre aux incidents et aux demandes d’assistance et d’évolution</span>
            <span class="description">Mettre à disposition des utilisateurs un service informatique</span>
            <span class="description">Développer la présence en ligne de l’organisation</span>
            <span class="description">Travailler en mode projet</span>
          </div>
          <p>Développement d'un site web pour mon Application Pokepuller. Ce site web sert à présenter
            l'application,
            inviter l'application sur un serveur Discord, voir les conditions générales d'utilisations et la
            politique de gestion des données privées.

          </p>
          <div class="tags">
            <span class="tag">JavaScript</span>
            <span class="tag">Node.js</span>
            <span class="tag">Vite.js</span>
            <span class="tag">Express.js</span>
            <span class="tag">Nginx</span>
            <span class="tag">PostgreSQL</span>
          </div>
          <div class="view-more">Voir plus de détails</div>
        </div>
      </div>

      <div class="timeline-item left">
        <div class="projet-card internship clickable" @click="$router.push('/stage-ifremer25')">
          <div class="date">Mai 2025</div>
          <div class="projet-title">
            <img src="@/assets/logo_ifremer.png" alt="Logo Ifremer" class="projet-icon">
            <h3>Stage Ifremer 2025</h3>
          </div>
          <div class="project-descriptions">
            <span class="description">Gérer le patrimoine informatique</span>
            <span class="description">Répondre aux incidents et aux demandes d’assistance et d’évolution</span>
            <span class="description">Mettre à disposition des utilisateurs un service informatique</span>
            <span class="description">Travailler en mode projet</span>
          </div>
          <p>
            Stage en administration de services à Ifremer.
            La mission était de faire des recherches sur le fonctionnement et la structure de données de l'ancien
            système
            de ticketing d'Ifremer et du nouveau afin de concevoir un script avec Python afin de transférer
            l'intégralité des données sans pertes
            d'une solution à l'autre.
          </p>
          <div class="tags">
            <span class="tag">Python</span>
            <span class="tag">Mantis</span>
            <span class="tag">Youtrack</span>
            <span class="tag">Ticketing</span>
            <span class="tag">PostgreSQL</span>
            <span class="tag">API</span>
            <span class="tag">Git</span>
          </div>
          <div class="view-more">Voir plus de détails</div>
        </div>
      </div>

      <div class="timeline-item right">
        <div class="projet-card personal clickable" @click="$router.push('/projet-pokepuller')">
          <div class="date">Avril 2025</div>
          <div class="projet-title">
            <img src="@/assets/logo_pokepuller.png" alt="Logo PokePuller" class="projet-icon">
            <h3>Bot Discord "PokePuller"</h3>
          </div>
          <div class="project-descriptions">
            <span class="description">Gérer le patrimoine informatique</span>
            <span class="description">Répondre aux incidents et aux demandes d’assistance et d’évolution</span>
            <span class="description">Mettre à disposition des utilisateurs un service informatique</span>
            <span class="description">Développer la présence en ligne de l’organisation</span>
            <span class="description">Travailler en mode projet</span>
          </div>
          <p>Développement d'un bot Discord en JavaScript sur Node.js permettant aux utilisateurs de tirer des
            boosters Pokémon du TCG officiel. Ce bot de jeu offre une expérience ludique aux membres du
            serveur en simulant l'ouverture de boosters virtuels avec des cartes collectionnables. Le
            système inclut une économie virtuelle, des statistiques de collection et des événements spéciaux
            programmés. Une api pour gérer les données des cartes a également été conçue.</p>
          <div class="tags">
            <span class="tag">JavaScript</span>
            <span class="tag">Node.js</span>
            <span class="tag">Python</span>
            <span class="tag">Discord.js</span>
            <span class="tag">Express.js</span>
            <span class="tag">PostgreSQL</span>
            <span class="tag">Canvas</span>
            <span class="tag">Axios</span>
            <span class="tag">Cron</span>
            <span class="tag">Git</span>
            <span class="tag">API</span>
          </div>
          <div class="view-more">Voir plus de détails</div>
        </div>
      </div>

      <div class="timeline-item left">
        <div class="projet-card educational">
          <div class="date">février 2025</div>
          <h3>Création de Site Web</h3>
          <div class="project-descriptions">
            <span class="description">Organiser son développement professionnel</span>
          </div>
          <p>Développement d'un site web personnel avec Vue.js pour présenter mon portfolio. Le site inclut
            une présentation de mes projets, compétences et expériences professionnelles.</p>
          <div class="tags">
            <span class="tag">Vue.js</span>
            <span class="tag">JavaScript</span>
            <span class="tag">HTML/CSS</span>
            <span class="tag">Git</span>
          </div>
        </div>
      </div>

      <div class="timeline-item right">
        <div class="projet-card educational clickable" @click="$router.push('/projet-geltram')">
          <div class="date">Janvier 2025</div>
          <div class="projet-title">
            <img src="@/assets/logo_geltram.png" alt="Logo GELTRAM" class="projet-icon" />
            <h3>Projet GELTRAM</h3>
          </div>
          <div class="project-descriptions">
            <span class="description">Gérer le patrimoine informatique</span>
            <span class="description">Répondre aux incidents et aux demandes d’assistance et d’évolution</span>
            <span class="description">Développer la présence en ligne de l’organisation</span>
            <span class="description">Travailler en mode projet</span>
          </div>
          <p>
            Projet d'AP du second semestre consistant à mettre en place un réseau
            d'entreprise fictif sur Proxmox en parallèle avec des équipements switch et
            routeur Cisco. J'ai implémenté plusieurs services : Active Directory, WSUS,
            IPAM, FOG, serveur web, DMZ, pfSense, Proxmox Backup Server, NAS SAN et GLPI.
            Ce projet a permis de développer des compétences avancées en administration
            système et réseau.
          </p>
          <div class="tags">
            <span class="tag">Proxmox</span>
            <span class="tag">Cisco</span>
            <span class="tag">Active Directory</span>
            <span class="tag">pfSense</span>
            <span class="tag">Virtualisation</span>
            <span class="tag">GLPI</span>
            <span class="tag">DMZ</span>
            <span class="tag">WSUS</span>
            <span class="tag">IPAM</span>
            <span class="tag">FOG</span>
            <span class="tag">Serveur Web</span>
            <span class="tag">NAS SAN</span>
          </div>
          <div class="view-more">Voir plus de détails</div>
        </div>
      </div>

      <div class="year-separator">
        <span class="year">2024</span>
      </div>

      <div class="timeline-item left">
        <div class="projet-card educational">
          <div class="date">Septembre 2024</div>
          <div class="projet-title">
            <img src="@/assets/logo_egnaro.png" alt="Logo Egnaro" class="projet-icon">
            <h3>Projet Egnaro</h3>
          </div>
          <p>Projet scolaire de réalisation d'un réseau d'entreprise simple avec des équipements Cisco
            (routeurs et switches).
            Ce projet comprend le déploiement de serveurs web hébergés sur des VM VirtualBox, un serveur
            DNS, un point d'accès WiFi,
            un script bash permettant de naviguer automatiquement sur les sites de l'entreprise, ainsi que
            l'installation
            d'un client léger AXEL fonctionnant en XRDP avec une VM Debian.</p>
          <div class="tags">
            <span class="tag">Cisco</span>
            <span class="tag">VirtualBox</span>
            <span class="tag">Serveur Web</span>
            <span class="tag">DNS</span>
            <span class="tag">WiFi</span>
            <span class="tag">Bash</span>
            <span class="tag">XRDP</span>
            <span class="tag">Client Léger</span>
            <span class="tag">Debian</span>
          </div>
        </div>
      </div>

      <div class="year-separator">
        <span class="year">2023</span>
      </div>

      <div class="timeline-item right">
        <div class="projet-card educational">
          <div class="date">Décembre 2023</div>
          <h3>Réorientation Professionnelle</h3>
          <p>Décision de réorientation professionnelle, passant d'un Master en Informatique à un BTS SIO
            option SISR. Cette réorientation reflète une volonté de se concentrer sur les réseaux,
            l'administration système et la cybersécurité plutôt que sur le développement pur.</p>
          <div class="tags">
            <span class="tag">BTS SIO</span>
            <span class="tag">SISR</span>
            <span class="tag">Réseaux</span>
            <span class="tag">Cybersécurité</span>
          </div>
        </div>
      </div>

      <div class="timeline-item left">
        <div class="projet-card educational">
          <div class="date">Juin 2023</div>
          <h3>Licence Informatique</h3>
          <p>Obtention de la Licence Informatique. Formation complète couvrant le développement logiciel, la
            programmation système et le développement web. Projets réalisés en Java, C, et technologies web.
          </p>
          <div class="tags">
            <span class="tag">Java</span>
            <span class="tag">C</span>
            <span class="tag">SQL</span>
            <span class="tag">Algorithmique</span>
          </div>
        </div>
      </div>

      <div class="timeline-item right">
        <div class="projet-card internship">
          <div class="date">Mars 2023</div>
          <div class="projet-title">
            <img src="@/assets/logo_ifremer.png" alt="Logo Ifremer" class="projet-icon">
            <h3>Stage Développeur - Ifremer</h3>
          </div>
          <p>Stage de développement à Ifremer visant à moderniser des applications legacy en utilisant Node.js
            et OpenUI5. Les missions incluent la migration d'applications PHP, l'évaluation des
            performances, l'intégration avec des bases de données SQL, la configuration de
            l'authentification via CAS Ifremer (SAML), et l'utilisation de GitLab pour la gestion de
            versions.</p>
          <div class="tags">
            <span class="tag">Node.js</span>
            <span class="tag">OpenUI5</span>
            <span class="tag">SQL</span>
            <span class="tag">SAML</span>
            <span class="tag">GitLab</span>
            <span class="tag">Docker</span>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "ProjetsPage",
};
</script>

<style scoped>
.projets {
  padding: 2rem;
  min-height: 100vh;
}

h1 {
  color: #2196f3;
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 4rem;
}

.timeline {
  position: relative;
  max-width: 1300px;
  margin: 0 auto;
}

.timeline::after {
  content: '';
  position: absolute;
  width: 3px;
  background-color: #2196F3;
  top: 0;
  bottom: 0;
  left: 50%;
  margin-left: -3px;
  z-index: 1;
}

.timeline-item {
  position: relative;
  width: 42%;
  margin-bottom: 2rem;
  z-index: 2;
}

.timeline-item.left {
  left: 0;
  margin-top: -8rem;
}

.timeline-item.right {
  left: 58%;
  margin-top: -8rem;
}

/* Réinitialiser la marge pour le premier élément après un séparateur d'année */
.year-separator+.timeline-item {
  margin-top: 4rem !important;
}

/* Ligne horizontale */
.timeline-item::before {
  content: "";
  position: absolute;
  height: 2px;
  background-color: #2196f3;
  top: 50%;
}

.timeline-item.left::before {
  right: -100px;
  width: 100px;
}

.timeline-item.right::before {
  left: -100px;
  width: 100px;
}


/* Point sur la timeline */
.timeline-item::after {
  content: "";
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: #2196f3;
  border-radius: 50%;
  top: calc(50% - 10px);
}

.timeline-item:has(.projet-card.personal)::before,
.timeline-item:has(.projet-card.personal)::after {
  background-color: #FFD700;
}

.timeline-item:has(.projet-card.educational)::before,
.timeline-item:has(.projet-card.educational)::after {
  background-color: #2196F3;
}

.timeline-item:has(.projet-card.internship)::before,
.timeline-item:has(.projet-card.internship)::after {
  background-color: #4CAF50;
}

.timeline-item.left::after {
  right: -112px;
}

.timeline-item.right::after {
  left: -116px;
}

.projet-card {
  padding: 25px;
  background: rgba(1, 1, 11, 0.95);
  border: 1px solid;
  border-radius: 8px;
}

.date {
  color: #64b5f6;
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
}

.projet-card.personal .date,
.projet-card.personal .view-more {
  color: #FFD700;
}

.projet-card.educational .date,
.projet-card.educational .view-more {
  color: #64B5F6;
}

.projet-card.internship .date,
.projet-card.internship .view-more {
  color: #4CAF50;
}

.projet-card h3 {
  font-size: 2rem;
  margin-bottom: 1.5rem;
}

.projet-card p {
  color: #b0bec5;
  line-height: 1.6;
  margin-bottom: 2rem;
  font-size: 1.1rem;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.tag {
  padding: 0.5rem 1.2rem;
  border-radius: 20px;
  font-size: 1rem;
  border: 1px solid;
}

.projet-card.personal .tag {
  background: rgba(255, 215, 0, 0.1);
  color: #FFD700;
  border-color: #FFD700;
}

.projet-card.educational .tag {
  background: rgba(33, 150, 243, 0.1);
  color: #64B5F6;
  border-color: #2196F3;
}

.projet-card.internship .tag {
  background: rgba(76, 175, 80, 0.1);
  color: #4CAF50;
  border-color: #4CAF50;
}

/* Couleurs spécifiques */
.projet-card.personal {
  border-color: #ffd700;
}

.projet-card.personal h3 {
  color: #ffd700;
}

.projet-card.educational {
  border-color: #2196f3;
}

.projet-card.educational h3 {
  color: #2196f3;
}

.projet-card.internship {
  border-color: #4caf50;
}

.projet-card.internship h3 {
  color: #4caf50;
}

/* Légende */
.color-legend {
  position: fixed;
  top: 2rem;
  right: 2rem;
  background-color: rgba(1, 1, 11, 0.95);
  padding: 1rem;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.color-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.color-dot.personal {
  background-color: #ffd700;
}

.color-dot.educational {
  background-color: #2196f3;
}

.color-dot.internship {
  background-color: #4caf50;
}

.legend-text {
  color: white;
  font-size: 1rem;
}

/* Styles pour le séparateur d'année */
.year-separator {
  position: relative;
  text-align: center;
  margin: 4rem 0;
  z-index: 2;
}

.year {
  background-color: #2196f3;
  color: white;
  padding: 0.5rem 2rem;
  border-radius: 20px;
  font-size: 1.2rem;
  font-weight: bold;
  display: inline-block;
  position: relative;
}

.projet-card.clickable {
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
  position: relative;
}

.projet-card.personal.clickable:hover {
  transform: translateY(-5px);
  box-shadow: 0 30px 60px rgba(255, 215, 0, 0.2);
  /* Ombre jaune pour projets personnels */
}

.projet-card.educational.clickable:hover {
  transform: translateY(-5px);
  box-shadow: 0 30px 60px rgba(33, 150, 243, 0.2);
  /* Ombre bleue pour projets éducatifs */
}

.projet-card.internship.clickable:hover {
  transform: translateY(-5px);
  box-shadow: 0 30px 60px rgba(76, 175, 80, 0.2);
  /* Ombre verte pour projets de stage */
}

.view-more {
  color: #64b5f6;
  text-align: right;
  margin-top: 1rem;
  font-weight: 500;
}

.projet-card.clickable:hover .view-more {
  text-decoration: underline;
}

.projet-title {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.projet-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid;
}

.projet-card.personal .projet-icon {
  border-color: #ffd700;
}

.projet-card.educational .projet-icon {
  border-color: #2196f3;
}

.projet-card.internship .projet-icon {
  border-color: #4caf50;
}

.projet-icon-fa {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  flex-shrink: 0;
}

.projet-card.internship .projet-icon-fa {
  border-color: #4caf50;
  color: #4caf50;
  background: rgba(76, 175, 80, 0.1);
}

.project-descriptions {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  margin-bottom: 1.5rem;
  margin-left: 50px;
  /* Pour aligner avec le texte */
}

.description {
  font-size: 0.85rem;
  font-style: italic;
  padding: 0.15rem 0.6rem;
  border-radius: 4px;
  border-left: 2px solid;
  display: inline-block;
}

.projet-card.educational .description {
  color: #90CAF9;
  background: rgba(33, 150, 243, 0.1);
  border-color: rgba(33, 150, 243, 0.5);
}

.projet-card.internship .description {
  color: #A5D6A7;
  background: rgba(76, 175, 80, 0.1);
  border-color: rgba(76, 175, 80, 0.5);
}

.projet-card.personal .description {
  color: #FFE082;
  background: rgba(255, 215, 0, 0.1);
  border-color: rgba(255, 215, 0, 0.5);
}

/* Pour les projets à gauche */
.timeline-item.left .project-descriptions {
  margin-left: 50px;
}

/* Pour les projets à droite */
.timeline-item.right .project-descriptions {
  margin-left: 50px;
}


@media screen and (max-width: 768px) {
  .timeline::after {
    left: 31px;
  }

  .timeline-item {
    width: 100%;
    padding-left: 70px;
    margin-bottom: 3rem;
  }

  .timeline-item.left,
  .timeline-item.right {
    left: 0;
  }

  .timeline-item::before,
  .timeline-item.right::before,
  .timeline-item.left::before {
    left: 60px;
    width: 50px;
  }

  .timeline-item::after,
  .timeline-item.right::after,
  .timeline-item.left::after {
    left: 22px;
  }

  .year-separator {
    text-align: left;
    margin-left: 50px;
  }
}
</style>
